(function () {

  function getProductHandle(url) {
    try {
      const path = url.includes('://') ? new URL(url).pathname : url;
      const match = path.match(/\/products\/([^?#/]+)/);
      return match ? match[1] : null;
    } catch (e) {
      return null;
    }
  }

  async function switchCardToProduct(card, handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return;
    const product = await res.json();
    const variant = product.variants[0];

    // --- Update navigation links ---
    card.querySelectorAll('a.product-card__link, a[ref="cardGalleryLink"], a[ref="productTitleLink"], a.group-block__link, a.contents').forEach(el => {
      if (!el.classList.contains('range-swatch')) {
        el.href = `/products/${handle}`;
      }
    });

    // --- Update product images ---
    const productImages = card.querySelectorAll('.product-media img.product-media__image');
    if (productImages.length > 0 && product.images && product.images.length > 0) {
      const featuredSrc = typeof product.featured_image === 'string'
        ? product.featured_image
        : product.featured_image?.src || product.images[0].src;

      const baseUrl = featuredSrc.split('?')[0];
      const full500 = `${baseUrl}?width=500`;

      const mainImg = productImages[0];
      mainImg.src = full500;
      mainImg.srcset = [
        `${baseUrl}?width=240 240w`,
        `${baseUrl}?width=352 352w`,
        `${baseUrl}?width=500 500w`
      ].join(', ');
      mainImg.alt = product.title;
      mainImg.setAttribute('data_max_resolution', full500);

      if (productImages[1] && product.images[1]) {
        const hoverSrc = typeof product.images[1] === 'string'
          ? product.images[1]
          : product.images[1].src;
        const hoverBase = hoverSrc.split('?')[0];
        const hover500 = `${hoverBase}?width=500`;
        productImages[1].src = hover500;
        productImages[1].srcset = [
          `${hoverBase}?width=240 240w`,
          `${hoverBase}?width=352 352w`,
          `${hoverBase}?width=500 500w`
        ].join(', ');
        productImages[1].alt = product.title;
        productImages[1].setAttribute('data_max_resolution', hover500);
      }
    }

    // --- Update price ---
    card.querySelectorAll('.price').forEach(el => {
      if (!el.closest('.range-swatches')) {
        el.textContent = `£${(variant.price / 100).toFixed(2)}`;
      }
    });

    // --- Update title ---
    card.querySelectorAll('.text-block p').forEach(el => {
      if (!el.closest('.range-swatches') &&
        !el.textContent.toLowerCase().includes('per roll') &&
        el.textContent.trim().length > 5) {
        const logoImg = el.querySelector('img');
        if (logoImg) {
          for (const node of el.childNodes) {
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 2) {
              const cleanTitle = product.title.replace(/^V&A\s+/i, '').replace(/^V&amp;A\s+/i, '');
              node.textContent = ' ' + cleanTitle;
              break;
            }
          }
        } else {
          el.textContent = product.title;
        }
      }
    });

    // --- Update h3 title if present ---
    const h3 = card.querySelector('h3');
    if (h3) h3.textContent = product.title;

    // --- Update quick-add variant ID ---
    const variantInput = card.querySelector('input[ref="variantId"]');
    if (variantInput) variantInput.value = variant.id;

    // --- Update order sample button ---
    const sampleBtn = card.querySelector('order-sample-button');
    if (sampleBtn) {
      const sampleVariant = product.variants.find(v => v.title.toLowerCase() === 'sample') || product.variants[1];
      if (sampleVariant) {
        sampleBtn.setAttribute('data-variant-id', sampleVariant.id);
        sampleBtn.setAttribute('data-product-id', product.id);
      }
    }

    // --- Update product form ---
    const productForm = card.querySelector('product-form-component');
    if (productForm) productForm.setAttribute('data-product-id', product.id);

    card.setAttribute('data-product-id', product.id);

    // --- Update active swatch state ---
    card.querySelectorAll('.range-swatch').forEach(s => {
      const swatchHandle = getProductHandle(s.getAttribute('href') || '');
      const isActive = swatchHandle === handle;
      s.classList.toggle('range-swatch--current', isActive);
      s.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function initCard(card) {
    if (card.dataset.swatchSwitchInit) return;
    card.dataset.swatchSwitchInit = 'true';

    card.addEventListener('click', async (e) => {
      const swatch = e.target.closest('.range-swatch');
      if (!swatch) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const handle = getProductHandle(swatch.getAttribute('href') || '');
      if (!handle) return;

      card.style.opacity = '0.6';
      card.style.pointerEvents = 'none';

      try {
        await switchCardToProduct(card, handle);
      } catch (err) {
        console.error('Swatch switch error:', err);
      } finally {
        card.style.opacity = '';
        card.style.pointerEvents = '';
      }
    }, { capture: true });
  }

  function initAll() {
    document.querySelectorAll('product-card').forEach(initCard);
  }

  Promise.all([
    customElements.whenDefined('product-card'),
  ]).then(() => {
    initAll();
  });

  if (!window.__swatchSwitchObserverInit) {
    window.__swatchSwitchObserverInit = true;
    const obs = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'PRODUCT-CARD') initCard(node);
          else if (node.querySelectorAll) node.querySelectorAll('product-card').forEach(initCard);
        });
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

})();